import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerCard } from './models/customer-card';
import { Store } from '@ngrx/store';

import * as SELECTORS from './+state/cards.selectors';
import * as ACTIONS from './+state/cards.actions';
import { map } from 'rxjs/operators';

@Injectable()
export class CardsNgrxFacade {
    customerCards$: Observable<CustomerCard[]> = this.store.select(SELECTORS.customerCards);
    customerCardsLoaded$: Observable<boolean> = this.store.select(SELECTORS.customerCardsLoaded);

    constructor(private store: Store) {}

    fetchCustomerCards(): void {
        this.store.dispatch(ACTIONS.fetchCustomerCards());
    }

    getCardById(cardId: number): Observable<CustomerCard> {
        return this.customerCards$.pipe(
            map((cards) => {
                return cards?.find((card) => card?.id === cardId);
            })
        );
    }

    getCardByRelatedCardId(relatedCardId: number): Observable<CustomerCard> {
        return this.customerCards$.pipe(
            map((cards) => {
                return cards?.find((card) => card?.relatedCardId === relatedCardId);
            })
        );
    }

    blockCard(card: CustomerCard) {
        this.store.dispatch(ACTIONS.blockCard({ card }));
    }

    unblockCard(card: CustomerCard) {
        this.store.dispatch(ACTIONS.unblockCard({ card }));
    }

    deleteRelatedCard(card: CustomerCard) {
        this.store.dispatch(ACTIONS.deleteRelatedCard({ card }));
    }
}
